import styled, { keyframes, css } from 'styled-components';

// Animacao de entrada de uma tag nova (quando o operador favorita uma
// variavel). Pop sutil pra confirmar a acao sem ser intrusivo.
const popIn = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  60% {
    transform: scale(1.08);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 14px;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const StarIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export const HeaderTitle = styled.span`
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.colors.darkerblue};
`;

// Contador X/8 com cor adaptativa:
//   - muted: 0 favoritos (cinza)
//   - ok: 1-7 favoritos (azul brand)
//   - warn: 8/8 atingido (laranja — limite)
export const Counter = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 2px 8px;
  height: 20px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.3px;
  background: ${(props) => {
    if (props.tone === 'warn')
      return props.theme.title === 'light'
        ? 'rgba(246, 154, 96, 0.18)'
        : 'rgba(246, 154, 96, 0.22)';
    if (props.tone === 'ok')
      return props.theme.title === 'light'
        ? 'rgba(0, 159, 216, 0.12)'
        : 'rgba(59, 191, 241, 0.18)';
    return props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.06)'
      : 'rgba(255, 255, 255, 0.08)';
  }};
  color: ${(props) => {
    if (props.tone === 'warn') return props.theme.colors.orange;
    if (props.tone === 'ok') return props.theme.colors.lightblue;
    return props.theme.colors.label;
  }};
`;

export const HelperText = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${(props) =>
    props.warn ? props.theme.colors.orange : props.theme.colors.label};
  opacity: 0.85;
  font-style: italic;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const VarTag = styled.div`
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 8px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 159, 216, 0.10)'
      : 'rgba(59, 191, 241, 0.14)'};
  color: ${(props) => props.theme.colors.lightblue};
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
  font-variant-numeric: tabular-nums;

  ${(props) =>
    props.entering &&
    css`
      animation: ${popIn} 600ms cubic-bezier(0.34, 1.56, 0.64, 1);
    `}
`;
